<button
  (click)="toggle()"
  class="side-menu-btn btn-icon btn btn-theme"
  aria-label="Abrir menu"
>
  <i class="mdi mdi-menu text-white"></i>
</button>

<div class="side-menu-container bg-theme-dark" [ngClass]="{'open' : show}">
  <div class="brand-container">
    <ng-content select="app-brand-logo"></ng-content>
  </div>
  <div class="nav-list-item custom-scroll">
    <div class="nav-list-top">
      <ng-content></ng-content>
    </div>
    <div class="nav-list-bottom">
      <ng-content select="[bottom]"></ng-content>
    </div>
  </div>
</div>

<div  (click)="toggle()"  class="side-menu-backdrop" [ngClass]="{'open' : show}">
  <button class="btn btn-theme btn-icon" aria-label="Fechar menu">
    <i class="mdi mdi-menu-open"></i>
  </button>
</div>